/**
 * Side Menu List - Accordion Toggle
 * Isolated script - won't affect other menus
 *
 * Behavior:
 * - Items WITHOUT children: link navigates normally (no JS interception)
 * - Items WITH children:
 *   - 1st click on row → expands submenu (prevents navigation)
 *   - 2nd click on row → navigates to URL
 *   - Click on the × icon (when expanded) → closes submenu (prevents navigation)
 * - Active items stay expanded on page load (handled in Liquid)
 */

(function () {
  'use strict';

  function initSideMenu() {
    const sideMenuLists = document.querySelectorAll('.side-menu-list');

    if (!sideMenuLists.length) return;

    sideMenuLists.forEach((menuList) => {
      // Only attach to rows that have submenus
      const expandableRows = menuList.querySelectorAll('[data-has-submenu="true"]');

      expandableRows.forEach((row) => {
        // Prevent duplicate listeners
        if (row.dataset.sideMenuInitialized === 'true') return;
        row.dataset.sideMenuInitialized = 'true';

        row.addEventListener('click', handleRowClick);
      });
    });
  }

  function handleRowClick(event) {
    const row = event.currentTarget;
    const isExpanded = row.getAttribute('aria-expanded') === 'true';

    // Check if the click was on the toggle icon (× button when expanded)
    const clickedOnIcon = event.target.closest('.side-menu-item__toggle');

    // Case 1: Clicked the × icon while expanded → close it (prevent nav)
    if (isExpanded && clickedOnIcon) {
      event.preventDefault();
      event.stopPropagation();
      collapseRow(row);
      return;
    }

    // Case 2: Already expanded, clicked on text → allow navigation
    if (isExpanded) {
      return;
    }

    // Case 3: Not expanded → expand it (prevent nav)
    event.preventDefault();
    event.stopPropagation();
    expandRow(row);
  }

  function expandRow(row) {
    const parentItem = row.closest('.side-menu-item, .side-submenu-item');
    if (!parentItem) return;

    const submenu = parentItem.querySelector(
      ':scope > .side-submenu-list, :scope > .side-sub-submenu-list'
    );
    if (!submenu) return;

    row.setAttribute('aria-expanded', 'true');
    submenu.removeAttribute('hidden');
    parentItem.classList.add('is-open');
  }

  function collapseRow(row) {
    const parentItem = row.closest('.side-menu-item, .side-submenu-item');
    if (!parentItem) return;

    const submenu = parentItem.querySelector(
      ':scope > .side-submenu-list, :scope > .side-sub-submenu-list'
    );
    if (!submenu) return;

    row.setAttribute('aria-expanded', 'false');
    submenu.setAttribute('hidden', '');
    parentItem.classList.remove('is-open');
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSideMenu);
  } else {
    initSideMenu();
  }

  // Re-initialize after Shopify section reload (theme editor)
  document.addEventListener('shopify:section:load', initSideMenu);
})();
